import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* amplify */
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";
import Amplify from "aws-amplify";
import { createI18n } from 'vue-i18n';
import awsconfig from "./aws-exports";
import { store, key, ACTIONS } from "./store";
import navigatorLanguages from "navigator-languages";
console.log("app launched");
Amplify.configure(awsconfig);
const supportedLanguages = ["en", "de"];
const languages: string[] = navigatorLanguages();
const BreakException = {};
try {
  languages.forEach(element => {
    console.log("language " + element);
    if (supportedLanguages.includes(element.substring(0,2))) {
      console.log("set locale to supported language " + element);
      store.dispatch(ACTIONS.SET_LOCALE, element.substring(0,2));
      throw BreakException;
    }
  })
} catch (e) {
  console.log("found a supported language");
}
applyPolyfills().then(() => {
  defineCustomElements(window);
});
const messages = {
  de: {
    menu: {
      hello: 'Hallo ',
      messages: 'Nachrichten',
      story: 'Die Story',
      role: 'Deine Rolle',
      market: 'Abenteuer finden',
      games: 'Abenteuer finden',
    },
  },
  en: {
    menu: {
      hello: 'Hello ',
      messages: 'Messages',
      story: 'The Story',
      role: 'Your Role',
      market: 'Find Stories',
    },
  },
}

const i18n = createI18n({
  locale: languages[0],
  fallbackLocale: 'en',
  messages,
  legacy: false,
})

const app = createApp(App).use(store, key)
  .use(IonicVue)
  .use(router)
  .use(i18n);

router.isReady().then(() => {
  app.mount('#app');

});